export interface AiScribeSetup {
  /**
   * Developer/superadmin override. Set directly in DynamoDB on the aiScribeSetup JSON field.
   * false = AI Scribe disabled for this clinic regardless of the clinic admin's setting.
   * true or absent = defer to the clinic admin's `enabled` flag.
   */
  devEnabled?: boolean;
  /** When true, the AI Scribe feature is enabled for this clinic (clinic admin toggle). */
  enabled?: boolean;
  /** Sections the AI Scribe should extract findings for. Defaults to all except patientProfile. */
  sections?: string[];
}

export const AI_SCRIBE_ALL_SECTIONS = [
  'patientProfile',
  'findings',
  'history',
  'symptoms',
  'patientFile',
  'assessment'
] as const;

export type AIScribeSection = typeof AI_SCRIBE_ALL_SECTIONS[number];

export const AI_SCRIBE_SECTION_LABELS: Record<AIScribeSection, string> = {
  patientProfile: 'Patient Demographics',
  findings: 'Signs / Clinical Exams',
  history: 'Medical History & Medications',
  symptoms: 'Symptoms & Questionnaires',
  patientFile: 'Physical Characteristics & Phenotype',
  assessment: 'Impression / Recommendations / Goals'
};
